import Form from './form'
import connect from './connect'

export default connect(Form)
